var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-container"},[_c('div',{staticClass:"lcontainer--inner"},[_c('div',{staticClass:"c-helpAutomation-component",attrs:{"data-personalisation":""}})])])
}]

export { render, staticRenderFns }